<template>
  <div class="qualityClass">
    <el-row :gutter="20">
      <el-col :span="16">
        <h1 class="title">云分享优师资源</h1>
        <div class="condition">
          <el-form
            :model="qualityClassCondition"
            ref="qualityClassConditionForm">
            <!--精品资源名称-->
            <div class="qualityClassCondition">
              <el-form-item class="qualityClassName" label="优师资源名称：" label-width="130px">
                <el-input
                  size="small"
                  v-model="qualityClassCondition.CourseName"
                  placeholder="请输入名称"></el-input>
              </el-form-item>
              <el-form-item class="qualityClassBtns">
                <el-button size="small" type="primary" @click="searchQualityClass">查询</el-button>
                <el-button size="small" @click="resetQualityClassConditionForm">重置</el-button>
              </el-form-item>
            </div>
            <!--            省市学校-->
            <el-row class="qualityClassCondition" :gutter="15">
              <el-col :span="10">
                <el-form-item label="省-市-学校/单位：" label-width="130px">
                  <el-autocomplete
                    clearable
                    size="small"
                    v-model="selProvince"
                    class="inline-input"
                    :fetch-suggestions="fetchProvinceData"
                    placeholder="请输入省份名"
                    @select="selProvinceData"
                    @clear="clearProvinceData"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item>
                  <el-autocomplete
                    clearable
                    size="small"
                    v-model="selCity"
                    class="inline-input"
                    :fetch-suggestions="fetchCityData"
                    placeholder="请输入城市名"
                    @select="selCityData"
                    @clear="clearCityData"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item>
                  <el-autocomplete
                    clearable
                    size="small"
                    v-model="selSchool"
                    class="inline-input"
                    :fetch-suggestions="fetchSchoolData"
                    placeholder="请输入学校名"
                    @select="selSchoolData"
                    @clear="clearSchoolData"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
<!--        @filter-change="qualityClassTableColumnFilter"-->
        <el-table
          :highlight-current-row="true"
          ref="qualityClassTable"
          @cell-click="cellClick"
          header-row-class-name="tableHeader"
          :stripe="true"
          :border="false"
          @sort-change="qualityClassTableColumnSort"
          :data="qualityClass">
          <el-table-column
            prop="CourseName"
            label="名称" width="300" align="left">
          </el-table-column>
          <el-table-column label="精品标记" width="100">
             <template slot-scope="scope">
               <el-tag v-if="scope.row.QualityMark == 1" size="small" type="info" effect="dark">精品</el-tag>
             </template>
           </el-table-column>
          <!--省市学校-->
          <el-table-column
            prop="SchoolName"
            sortable="custom"
            label="省-市-学校/单位"
            min-width="160">
          </el-table-column>
          <!--作者-->
          <!-- :filters="teacherFilters" :filter-method="(val,row,column)=>val===row.TeacherID"-->
          <el-table-column
            width="100"
            prop="TeacherName"
            label="作者">
          </el-table-column>
          <!--时间-->
          <el-table-column
            sortable="custom"
            width="160"
            prop="SharedTime"
            label="分享时间">
          </el-table-column>
          <!--状态 :filters="stateFilters"
            :filter-method="qualityClassTableColumnFilter_ShowState"-->
          <el-table-column
            sortable="custom"
            width="120"
            prop="ShowState"
            label="状态">
          </el-table-column>
          <!--操作区-->
          <el-table-column
            width="160"
            fixed="right"
            label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.ShowState.trim()===store.state.qualityClassState.added.dis && scope.row.TeacherID != loginTeacherID"
                type="text" size="medium"
                @click="deleteClassicCourseTeachingPlan(scope)">
                取消添加
              </el-button>
              <el-button
                v-if="scope.row.ShowState.trim()===store.state.qualityClassState.notAdded.dis && scope.row.TeacherID != loginTeacherID"
                type="text" size="medium"
                @click="addClassicCourseTeachingPlan(scope)">
                添加
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="qualityClassPaginationChange"
          :page-size="qualityClassPagination.pageSize"
          :pager-count="qualityClassPagination.pageCounter"
          layout="prev, pager, next,jumper"
          :total="qualityClassPagination.total">
        </el-pagination>
      </el-col>
      <el-col :span="8" class="rightVideo">
        <div class="rVideo">
          <div class="title">{{qualityClassVideo ? qualityClassVideo.CourseName : ''}}</div>
          <div class="video">
            <video
              controls
              :src="qualityClassVideo ? qualityClassVideo.VideoPath : ''"></video>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "QualityClass",
    //定义接收的属性
    props: {
      chapterId: [String, Number], // 章节ID
      TeachingPlanId: [String, Number], //课时ID
    },
    data() {
      return {
        /*精品资源数据开始*/
        qualityClass: [],
        //精品资源分页信息
        qualityClassPagination: {
          pageSize: 1,//每页多少行
          total: 0,//总行数
          pageCounter: 11,//折叠数,只能为单数....神奇啊
        },
        showQualityClassVideo: false, //视频播放
        qualityClassVideo: { //当前选择的视频.
        },
        //精品资源搜索条件.
        //重置与第一次搜索时的条件
        qualityClassCondition: {
          CurrentPage: 1,//搜索第几页
          PageSize: 10,//每页多少行
          //ChapterID:this.ChapterID,
          ChapterID: this.chapterId,
          TeachingPlanID:this.TeachingPlanId,
          CourseName: '',
          ProvinceID: '',
          CityID: '',
          AreaID: '',
          SchoolID: '',
          //过滤的几个字段
          TeacherID: '', // 作者id.
          /*ExpertID: '',  //专家*/
          /*SourceType: '', //来源*/
          /*ShowState: '', //状态.*/
          Sort: [
            {SortField: "SharedTime", SortType: "desc"}
          ]
        },
        provinceData: [],//省data
        selProvince: '',//当前选择的省份.
        cityData: [], //市data
        selCity: '', //当前选择的市.
        schoolData: [],
        selSchool: '',

        teacherFilters: [],//字段过滤作者
        expertFilters: [],///字段过滤 审核专家
        sourceFilters: [],///字段过滤  来源
        stateFilters: [],///字段过滤  状态


        /*精品资源数据结束*/
        loginTeacherID : localStorage["TeacherID"],
      }
    },
    methods: {
      /*精品资源相关 开始*/
      // 获取精品资源
      getClassicCourseListAuditedBySearchPage() {
        console.log(this.qualityClassCondition);
        this.axios.post(window.url + 'GetClassicCourseListAuditedBySearchPage', this.qualityClassCondition)
          .then(res => {

            if (res.data.result == 200) {
              let resData = res.data.data;
              this.qualityClass = resData.Content;
              this.qualityClassVideo = this.qualityClass && this.qualityClass.length > 0 ? this.qualityClass[0] : null;
              this.qualityClassPagination.total = resData.totalSize;
              this.qualityClassPagination.pageSize = resData.pageSize;
              //获取作者/专家/来源/状态的过滤数据
              /*this.expertFilters = resData.expertFilters;*/
              this.sourceFilters = resData.sourceFilters;
              this.stateFilters = resData.stateFilters;
              this.teacherFilters = resData.teacherFilters;
            } else {
              this.$message.error(res.data.message);
            }
          }).catch(error => {
          this.$message.error(error);
        })
      },

      //分页显示
      qualityClassPaginationChange(e) {

        this.qualityClassCondition.CurrentPage = +e;
        this.getClassicCourseListAuditedBySearchPage();
      },
      //删除精品资源
      deleteClassicCourseTeachingPlan(scope) {

        let condition = {
          TeachingPlanID: this.TeachingPlanId,//备课信息id、
          ClassicCourseID: scope.row.ID,//精品资源id、
          // ChapterID: this.chapterId,//绑定的章节id
        }
        this.axios.post(window.url + 'DeleteClassicCourseTeachingPlan ', condition)
          .then(res => {

            if (res.data.result === 200) {
              this.$message.success('操作成功');
              this.getClassicCourseListAuditedBySearchPage();
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(error => {
            //异常
            this.$message.error('无响应,请稍后再试！');
          })
      },
      //添加精品资源
      addClassicCourseTeachingPlan(scope) {
        let condition = {
          TeachingPlanID: this.TeachingPlanId,//备课信息id、
          ClassicCourseID: scope.row.ID,//精品资源id、
          ChapterID: this.chapterId,//绑定的章节id
        }
       // return;
        this.axios.post(window.url + 'AddClassicCourseTeachingPlan', condition).then(
          res => {

            if (res.data.data) {
              this.$message.success('操作成功');
              this.getClassicCourseListAuditedBySearchPage();
            } else {
              this.$message.error(res.data.message);
            }
          }
        );
      },
      cellClick(row, column) {

        if (column.property == 'CourseName') {
          this.showQualityClassVideo = true;
          this.qualityClassVideo = row;
        }
      },
      // 搜索精品资源,单写是为了验证,备留
      searchQualityClass() {
        this.$refs['qualityClassConditionForm'].validate((valid) => {
          if (valid) {
            this.getClassicCourseListAuditedBySearchPage();
          } else {
            return false;
          }
        });
      },
      //搜索全部重置
      resetQualityClassConditionForm() {

        // this.$refs['qualityClassConditionForm'].resetFields();
        this.qualityClassCondition = {
          CurrentPage: 1,//搜索第几页
          PageSize: 10,//每页多少行
          //ChapterID:this.ChapterID,
          ChapterID: this.chapterId,
          TeachingPlanID:this.TeachingPlanId,
          CourseName: '',
          ProvinceID: '',
          CityID: '',
          AreaID: '',
          SchoolID: '',
          Sort: [
            {SortField: "SharedTime", SortType: "desc"}
          ],
          TeacherName: '',
          /*ExpertName: '',
          SourceType: '',
          ShowState: '',*/
        };
        this.selProvince = '';//省重置
        this.selCity = '';//市重置
        this.selSchool = '';//学校重置
        //过滤器重置
        this.$refs.qualityClassTable.clearFilter();
        this.getClassicCourseListAuditedBySearchPage();
      },
      //列排序
      qualityClassTableColumnSort(column, prop, order) {
        // "Sort":[{"SortField":"AddTime\SchoolID\Source\State","SortType":"asc\desc"}]
        switch (column.prop) {
          case "SchoolName":
            this.qualityClassCondition.Sort[0].SortField = "SchoolID";
            break;
          case "SourceType":
            this.qualityClassCondition.Sort[0].SortField = "Source";
            break;
          case "ShowState":
            this.qualityClassCondition.Sort[0].SortField = "State";
            break;
          case "SharedTime":
            this.qualityClassCondition.Sort[0].SortField = "SharedTime";
            break;
        }
        this.qualityClassCondition.Sort[0].SortType = column.order == 'ascending' ? 'asc' : 'desc';
        this.getClassicCourseListAuditedBySearchPage();
      },
      //作者,专家,来源,状态 过滤品
      // qualityClassTableColumnFilter(value) { //筛选只会传递一个value值
      //   console.log("筛选的值:",value);
      //   let tmpArr = value[Object.keys(value)[0]];
      //   this.qualityClassCondition[tmpArr[0]] = tmpArr.slice(1).join();
      //   this.getClassicCourseListAuditedBySearchPage();
      // },
      /*由原来根据条件筛选, 改为当页筛选*/
      qualityClassTableColumnFilter_SourceType(val,row,column){
        // console.log(val,row,column);
        if(val===1)   return row.SourceType==="自制";
        return  row.SourceType==="云精品"
      },
      qualityClassTableColumnFilter_ShowState(val,row,column){
       //console.log(val,row,column);
        if(val)   return row.ShowState==="已添加";
        return  row.ShowState==="未添加"
      },

      //来源

      //状态

      /*精品资源相关 结束*/



      /* 省级开始  , 获取省列表 */
      getProvince(pid) {
        this.axios.post(window.url + 'GetListAreaLvl', {Pid: pid || -1})
          .then(
            res => {

              if (res.data.result === 200) {
                //如果无值, 则为省份
                if (!pid) {
                  let provinceData = res.data.data;
                  // 数据过滤,改变属性名
                  provinceData.filter((val, i, arr) => {
                    val.value = val.CityName;
                    delete val.CityName;
                  });
                  this.provinceData = provinceData;
                } else { //有值则代表市级

                  let cityData = res.data.data;
                  // 数据过滤,改变属性名
                  cityData.filter((val, i, arr) => {
                    val.value = val.CityName;
                    delete val.CityName;
                  });
                  this.cityData = cityData;
                }
              }
            }
          )
      },
      //省输入后的筛选,
      fetchProvinceData(queryStr, callBackFun) {

        // 数组过滤
        let provinceData = this.provinceData.filter((val) => {
          //判断val中是否有queryStr
          if (val.value.indexOf(queryStr) !== -1) {
            return val
          }
        });
        callBackFun(provinceData);

      },
      clearProvinceData() {
        this.resourceCondition.ProvinceID = '';
        this.selCity = '';
        this.selSchool = '';
        this.resourceCondition.CityID = '';
        this.resourceCondition.SchoolID = '';
        this.cityData = [];
        this.schoolData = [];
      },
      //省选择后的修改
      selProvinceData(item) {
        this.qualityClassCondition.ProvinceID = item.CityCode;
        this.getProvince(item.CityCode);
        this.selCity = '';
        this.selSchool = '';
        this.resourceCondition.CityID = '';
        this.resourceCondition.SchoolID = '';
      },
      /* 省级结束, 获取省列表 */


      /* 市级开始  , 获取市列表 */
      fetchCityData(queryStr, callBackFun) {

        // 数组过滤
        let cityData = this.cityData.filter((val) => {
          //判断val中是否有queryStr
          if (val.value.indexOf(queryStr) !== -1) {
            return val
          }
        });
        callBackFun(cityData);

      },

      clearCityData() {
        this.resourceCondition.CityID = '';
        this.selSchool = '';
        this.resourceCondition.SchoolID = '';
        this.schoolData = [];
      },
      selCityData(item) {

        this.qualityClassCondition.CityID = item.CityCode;
        this.selSchool = '';
        this.resourceCondition.SchoolID = '';
        this.getSchoolListByArea(item.CityCode)
      },
      /* 市级开始  , 获取市列表 */


      /*学校选择开始*/
      // 获取学校列表
      getSchoolListByArea(Code) {
        this.axios.post(window.url + 'GetSchoolListByArea', {Code: Code})
          .then(
            res => {

              if (res.data.result === 200) {
                //如果无值, 则为省份
                let schoolData = res.data.data;
                // 数据过滤,改变属性名
                schoolData.filter((val, i, arr) => {
                  val.value = val.Name;
                  delete val.Name;
                });
                this.schoolData = schoolData;
              }
            })
      },
      fetchSchoolData(queryStr, callBackFun) {

        // 数组过滤
        let schoolData = this.schoolData.filter((val) => {
          //判断val中是否有queryStr
          if (val.value.indexOf(queryStr) !== -1) {
            return val
          }
        });
        callBackFun(schoolData);

      },
      clearSchoolData() {
        this.resourceCondition.SchoolID = '';
      },
      selSchoolData(item) {
        this.qualityClassCondition.SchoolID = item.Id;
      },
      /*学校选择结束*/

    },
    mounted() {
      this.getProvince();//获取省份信息.
      this.getClassicCourseListAuditedBySearchPage();
    }
  }
</script>

<style lang="less" scoped>
  .qualityClass {
    height: 100%;

    .el-row {
      height: 100%;

      .el-col {
        height: 100%;
      }
    }

    h1.title {
      background: #409EFF;
      color: #fff;
      height: 50px;
      font-size: 32px;
      font-weight: bold;
      line-height: 50px;
      margin-bottom: 22px;
    }

    /*搜索条件开始*/

    .condition {
      margin-bottom: 10px;

      .qualityClassCondition {
        display: flex;

        .el-form-item {
          margin-bottom: 6px;
        }

        .qualityClassName {
          flex: 1 1 auto;
          margin-right: 12px;
        }

        .qualityClassBtns {
          width: 160px;
          text-align: right;
        }

        .el-autocomplete {
          display: block;
        }
      }
    }


    /*搜索条件结束*/

    /deep/ .el-tabs__header {
      .el-tabs__item {
        font-size: 20px;
      }
    }

    .el-table {
      margin-bottom: 10px;

      /deep/ td, th {
        padding: 5px 0;
      }

      /deep/ .el-table__row {

      }
    }

    /deep/ .tableHeader {
      background: #F6F6F6;

      th {
        background: #F6F6F6;
        color: #2c3e50;

        .cell.highlight {
          /*background: #F6F6F6;*/
          color: #2c3e50;
        }
      }
    }

    /deep/ .el-table__body {
      tbody {
        tr {
          td:first-child:hover {
            /*text-decoration: underline;*/
            cursor: pointer;
            color: #409EFF;
          }
        }
      }
    }

    .rightVideo{
      position: relative;
      .rVideo {
        position: absolute;
        top:50%;
        left:0;
        right:0;
        transform: translateY(-50%);
        .title {
          font-size: 1.8rem;

        }

        .video {

          video {
            width: 100%;
          }
        }
      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/detail/QualityClass.vue